module.exports = __webpack_public_path__ + "src/assets/images/zhanyong_moren.png";